import { Controller } from "@hotwired/stimulus"

// Minimal controller for handling field selection
export default class extends Controller {
  static targets = ["customFieldInput"]

  handleApplicationFieldChange(event) {
    const value = event.target.value
    
    if (value === 'custom') {
      this.showCustomFieldInput()
    } else {
      this.hideCustomFieldInput()
    }
  }

  showCustomFieldInput() {
    if (this.hasCustomFieldInputTarget) {
      this.customFieldInputTarget.classList.remove('hidden')
      const input = this.customFieldInputTarget.querySelector('input')
      if (input) input.focus()
    }
  }

  hideCustomFieldInput() {
    if (this.hasCustomFieldInputTarget) {
      this.customFieldInputTarget.classList.add('hidden')
      const input = this.customFieldInputTarget.querySelector('input')
      if (input) input.value = ''
    }
  }
}